/**
 * EventsGate: capability gate for Events pages.
 *
 * Route-level ProtectedRoute only knows roles, but Events capabilities are "role OR right"
 * (a user may hold Event.View without an Events role), so pages ask useEventsPermissions.
 */

import type { ReactNode } from 'react';
import { IconLock } from '@tabler/icons-react';
import { LayoutContainer } from '@/components/ui/layout';
import { EmptyState } from '@/components/ui/data-display';
import { useEventsPermissions, type EventsPermissions } from '@/hooks/events/useEventsPermissions';

interface EventsGateProps {
  allow: (p: EventsPermissions) => boolean;
  children: ReactNode;
}

export function EventsGate({ allow, children }: EventsGateProps) {
  const perms = useEventsPermissions();
  if (!allow(perms)) {
    return (
      <LayoutContainer>
        <EmptyState
          icon={<IconLock size={40} />}
          title="Access denied"
          description="You do not have permission to open this page. Ask an Events administrator for access."
        />
      </LayoutContainer>
    );
  }
  return <>{children}</>;
}
